// import node module libraries
import { Fragment } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

export const FormSelect = (props) => {
	const {
		placeholder,
		defaultselected,
		value, // optional controlled value
		options = [],
		id,
		name,
		style,
		onChange,
		required,
		disabled
	} = props;

	return (
		<Fragment>
			<Form.Select
				defaultValue={defaultselected}
				value={value}
				id={id}
				name={name}
				onChange={(e) => {
					if (onChange) {
						onChange(e.target.value, e);
					}
				}}
				required={required}
				disabled={disabled}
				style={style ? style : {}}
			>
				{placeholder ? (
					<option value="" className="text-muted">
						{placeholder}
					</option>
				) : (
					''
				)}
				{options.map((item, index) => {
					return (
						<option key={index} value={item.value} className="text-dark">
							{item.label}
						</option>
					);
				})}
			</Form.Select>
		</Fragment>
	);
};

FormSelect.propTypes = {
	placeholder: PropTypes.string,
	defaultselected: PropTypes.string,
	value: PropTypes.string,
	id: PropTypes.string,
	name: PropTypes.string,
	required: PropTypes.bool,
	disabled: PropTypes.bool,
	onChange: PropTypes.func,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
				.isRequired,
			label: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
				.isRequired
		})
	)
};

FormSelect.defaultProps = {
	placeholder: '',
	defaultselected: '',
	value: undefined,
	id: '',
	name: '',
	required: false,
	disabled: false,
	onChange: undefined,
	options: []
};

export default FormSelect;
